var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progressbar"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":100,"width":7}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }